import { gql } from "graphql-tag";
import { BulkAction, ModalService, DataService } from "@bb-vendure/admin-ui/core";
import { RemoveFanClubDocument } from "src/generated-gql/graphql";

const bulkRemove: BulkAction = {
  location: "fan-club-page",
  label: "Remove Selected",
  icon: "warning",
  iconClass: "is-warning",
  onClick: ({ selection, injector, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: `Remove ${selection.length} Fan Club?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Remove", returnValue: selection },
        ],
      })
      .subscribe((response) => {
        for (const item in response) {
          dataService
            .mutate(RemoveFanClubDocument, { id: response[item].id })
            .subscribe((r) => {
              hostComponent.refresh();
            });
        }
        clearSelection();
      });
  },
};

export { bulkRemove };
